"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _auth = require("@/api/auth");
var _auth2 = require("@/utils/auth");
var _vuePropertyDecorator = require("vue-property-decorator");
var _RePasswordForm = _interopRequireDefault(require("./RePasswordForm.vue"));
var OTPForm = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(OTPForm, _Vue);
  var _super = (0, _createSuper2.default)(OTPForm);
  function OTPForm() {
    var _this;
    (0, _classCallCheck2.default)(this, OTPForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "staffId", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "form", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loading", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "otpCode", "");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visibleRePassword", false);
    return _this;
  }
  (0, _createClass2.default)(OTPForm, [{
    key: "handleOnComplete",
    value: function handleOnComplete(value) {
      this.otpCode = value;
      this.handleSubmit();
    }
  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return _auth.authApi.verifyOtp({
                  staffId: this.staffId,
                  otp: this.otpCode
                });
              case 4:
                res = _context.sent;
                (0, _auth2.setToken)(res.data.token);
                this.$store.commit("user/SET_TOKEN", res.data.token);
                this.$router.push("/");
              case 8:
                _context.prev = 8;
                this.loading = false;
                return _context.finish(8);
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1,, 8, 11]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }]);
  return OTPForm;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], OTPForm.prototype, "staffId", void 0);
OTPForm = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    RePasswordForm: _RePasswordForm.default
  }
})], OTPForm);
var _default = OTPForm;
exports.default = _default;